<template>
	<header-block title="Boosted"></header-block>

	<div class="header-panel">
		<v-row class="content-row">
			<v-col class="v-col-8">
				<h1 class="boosted-title">Boosted</h1>
			</v-col>
			<v-col class="v-col-4 voucher-count">
				<span v-if="boostedVouchers">{{ boostedVouchers.length }} Vouchers</span>
			</v-col>
		</v-row>
		<img :src="require('@/assets/bg/boosted.png')" class="background" />
	</div>

	<div class="mt-6" v-if="boostedVouchers">
		<VoucherList 
			:showAll="true" 
			:vouchers="boostedVouchers" 
			:search="false" 
			:showSaving="false" 
			:showFavourites="true"
			@favouriteToggled="(v) => { favouriteToggled(v); }"
			:formatter="formatter" />
	</div>
	<div class="mt-6" v-else>
		<div v-for="i in 4" :key="i" class="mb-2">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
			></v-skeleton-loader>
		</div>
	</div>

	<p v-if="!loading && boostedVouchers.length==0" class="centered">
		There are no boosted vouchers available at this time.
	</p>

	<div style="clear:both; "></div>
	
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';

export default {
	mixins: [Services],
	components: {HeaderBlock, VoucherList},
	data() {
		return {
			boostedVouchers: null,
			loading: true
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer();
			this.loadAvailable();
		},
		loadAvailable: function(){
			this._getAvailableVouchers(() => {
				this.boostedVouchers = this.availableVouchers.filter(v => v.manualOverride);
				this.loading = false;
			});
		},
		favouriteToggled: function(voucher) {
			if (voucher.favourite) {
				this._removeCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			} else {
				this._addCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			}
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>
.header-panel {
	background-color: #281c3b;
	color: white;
	padding: 20px 30px;
	margin: -20px -30px;
	height: 108px;
	position: relative;
	overflow: hidden;
}

.content-row {
	position: relative;
	z-index: 1;
}

.header-panel h1 {
	font-size: 28px;
	font-weight: bold;
}

.voucher-count {
	text-align: right;
	align-self: center;
	font-size: 13px;
	margin-top: 30px;
}

.topTabButton
{
	margin-top: 0px;
	text-transform: none;
	padding-top: 17px !important;
	padding-bottom: 30px !important;
	vertical-align: middle !important;
	background-color: #ffffff66 !important;
	font-weight: bold;
}

.topTabButton.selected {
    background-color: var(--text-color) !important;
	color: white !important;
}

.topMenuCol {
	padding-left: 3px;
	padding-right: 3px;
}

.topMenuRow
{
	margin-left: -5px;
	margin-right: -5px;
	margin-bottom: 15px;
}

.background {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	z-index: 0;
}

.background-bolt {
	position: absolute;
	height: 150%;
	opacity: 1;
	z-index: 0;
	top: -25%;
}

h1.boosted-title {
	font-size: 28px;
	margin-top: 30px
}

</style>
